import { Component } from 'react';
import { Box, Button, Typography } from '@mui/material';

class ActivityErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Activity page render error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ py: 8, px: 2, textAlign: 'center' }}>
                    <Typography sx={{ color: '#f87171', mb: 2 }}>
                        Something went wrong loading activity history.
                    </Typography>
                    <Button
                        variant="outlined"
                        sx={{ color: '#fff', borderColor: '#fff' }}
                        onClick={() => window.location.reload()}
                    >
                        Reload page
                    </Button>
                </Box>
            );
        }
        return this.props.children;
    }
}

export default ActivityErrorBoundary;
